import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';
import { SearchBoxCSSStyleImpl } from '../../toolkit/toolbarwithsearch/searchbox/searchboxcss';

export class NameTuneSearchCSSStyle extends SearchBoxCSSStyleImpl
{
    getMainDivCSSStyle(): object 
    {
        return{
            width:'100%',height:'100%',borderRadius:'30px',backgroundColor:this.getResources().getColor(Colors.color_5),
            border:'1px solid'+this.getResources().getColor(Colors.color_8),
            display: "flex"
        };
    }    
    getSearchBoxImageDivCSSStyle(): object {
        return{
            width:"140px", height:"100%",
            backgroundColor:"#EAEDF0", 
            float:'right',
            borderRadius: '0px 30px 30px 0px',
            cursor: "pointer"
        };
    }
    getSearchBoxInputDivCSSStyle(): object 
    {
        return{
            flex: 1,height:'100%', paddingTop:'11px', lineHeight:'16px', paddingBottom:'10px',
            marginLeft:'20px', marginRight:'10px',outline:'none',border:'none',
            fontSize:this.getResources().getFont(Fonts.h7),
            fontWeight: 300,
            letterSpacing: 0,
            color:this.getResources().getColor(Colors.color_5),
            fontFamily: this.getResources().getFontFamily(),
        };

        
    }
    getSearchLabelCSSStyle():object
    {
        return{
            width:'100%',height:'16px',lineHeight:'16px',marginTop:'15px',fontSize:'20px',fontWeight:600,
            color:this.getResources().getColor(Colors.color_36),
            fontFamily: this.getResources().getFontFamily(),
            textAlign:'center'
        };
    }

  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/nametunes/nametunesearchcss.tsx